import { Controller, useFormContext } from 'react-hook-form';

import {
  EditorableSchema,
  FieldSchemaEditorSupportedTypes,
} from 'dashboard/components-lib/FieldSchemaEditor/constants';
import Checkbox from 'design-system/components/Checkbox';
import Spacer from 'design-system/components/Spacer';
import {
  FieldSchemaBoolean,
  FieldSchemaInteger,
  FieldSchemaNumber,
  FieldSchemaString,
  FieldSchemaType,
} from 'lib/fields';
import useFeatureFlag from 'lib/hooks/useFeatureFlag';

const hasComputedConfig = (
  schema: FieldSchemaEditorSupportedTypes,
): schema is FieldSchemaBoolean | FieldSchemaInteger | FieldSchemaNumber | FieldSchemaString => {
  return (
    schema.type === FieldSchemaType.Boolean ||
    schema.type === FieldSchemaType.Integer ||
    schema.type === FieldSchemaType.Number ||
    schema.type === FieldSchemaType.String
  );
};

interface ComputedFieldControlsProps {
  fieldSchema: EditorableSchema;
  fieldName: string;
  formContext: ReturnType<typeof useFormContext>;
  canEdit: (fieldSchema: EditorableSchema) => boolean;
}

const ComputedFieldControls: React.FC<ComputedFieldControlsProps> = ({
  fieldSchema,
  fieldName,
  formContext,
  canEdit,
}) => {
  const { control } = formContext;
  const isComputedFieldsEnabled = useFeatureFlag(
    'dashboard:enable-workflows-computed-field-triggers',
  );

  if (!isComputedFieldsEnabled || !hasComputedConfig(fieldSchema)) return <></>;

  return (
    <>
      <Spacer height={2} />
      <Controller
        name={`${fieldName}.config.computed`}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Checkbox
            label='Computed value'
            value={value}
            checked={value}
            disabled={!canEdit(fieldSchema)}
            onChange={onChange}
          />
        )}
      />
    </>
  );
};

export default ComputedFieldControls;
